/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function () {
//   $('body').on('click','.note_image_preview_block', function(e) {
//     e.preventDefault();
//     $('.note_cards').removeClass('hide');
//   });
  $('body').on('click', '.note_cards .note_image_block', function(e) {
    e.preventDefault();

    var parentBlock = $(this).closest('.note_cards');
    var oldSelectedBlock = parentBlock.find('.selected');
    oldSelectedBlock.removeClass('selected');
    $(this).addClass('selected');
    var attribute_title = $(this).find('h6').html();
    var imageSrc = $(this).find('img').attr('src');
    
    var ImageNoteInput = $('#ImageNote');
    var previewImageEl = $('.note_image_preview_block img');
    ImageNoteInput.val(attribute_title);
    previewImageEl.attr('src',imageSrc);
//     parentBlock.addClass('hide');
  });
});